import { getPathSegments, resolveAppSlug } from '../../shared/lib/appSlug'

const DEFAULT_APP_SLUG = 'default'

function resolveDashboardSlug(pathname: string): string {
  const segments = getPathSegments(pathname)
  if (segments[0] !== 'dashboard') {
    return DEFAULT_APP_SLUG
  }

  const slug = resolveAppSlug(segments[1])
  return slug.slug ?? DEFAULT_APP_SLUG
}

export function getDashboardAppSlug(pathname?: string): string {
  if (pathname) {
    return resolveDashboardSlug(pathname)
  }
  if (typeof window === 'undefined') {
    return DEFAULT_APP_SLUG
  }
  return resolveDashboardSlug(window.location.pathname)
}

export function getDashboardApiPath(appSlug = getDashboardAppSlug()): string {
  return `/api?app=${encodeURIComponent(appSlug)}`
}

export function getDashboardWebsocketPath(appSlug = getDashboardAppSlug()): string {
  return `/websocket?app=${encodeURIComponent(appSlug)}`
}

export function getDashboardAppHostPath(appSlug = getDashboardAppSlug()): string {
  return `/app/${appSlug}/`
}
